/**
 * 資料匯出 REST API client（docs/EXPORT_FEATURE_PLAN.md）
 *
 * Auth: 同 kb.ts —— Chainlit httponly cookie，同源 fetch 自動帶上。
 * 下載端點刻意不用 fetch：只回傳 URL，讓瀏覽器直接導向下載，
 * 由瀏覽器處理大檔與進度（不佔前端記憶體）。
 * 兩者都回 zip；對話紀錄 zip 內以 Excel 總表為主（決策 D8 移除了每對話一份的 .md）。
 */

const BASE = '/api/export';

export interface ExportKb {
  id: string;
  name: string;
  /** 該 KB 的文件總數（含無原檔者） */
  file_count: number;
  /** 有原始檔可下載的文件數（source_path 非空且檔案存在） */
  downloadable_count: number;
  /** 可下載原始檔的總 bytes */
  downloadable_bytes: number;
}

export interface ExportSummary {
  /** 無 KB 下載權限（org_viewer）時為 false，且 kbs 為空；頁面據此隱藏知識庫區塊 */
  kb_export_allowed: boolean;
  kbs: ExportKb[];
  conversations: { count: number; message_count: number };
  /** 後端單次 zip 上限（bytes），前端據此先擋 */
  max_zip_bytes: number;
}

export const exportApi = {
  summary: (): Promise<ExportSummary> =>
    fetch(`${BASE}/summary`, { credentials: 'include' }).then(async (res) => {
      if (!res.ok) {
        const text = await res.text().catch(() => res.statusText);
        throw new Error(text || `HTTP ${res.status}`);
      }
      return res.json();
    }),

  /** 所選知識庫原始檔 zip 的下載網址 */
  kbZipUrl: (ids: string[]): string =>
    `${BASE}/kb?ids=${encodeURIComponent(ids.join(','))}`,

  /** 登入者全部對話紀錄 zip（內含 Excel 總表）的下載網址 */
  conversationsUrl: (): string => `${BASE}/conversations`,
};
